var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Origin_1;
/* eslint-disable import/no-duplicates */
import { Utils } from '@symon-ai/wisepipe-common';
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './dataSource'; // force import for JsonSchemaV2
import './importConfigs/importConfig'; // force import for JsonSchemaV2
import { ImportConfigType } from './importConfigs/importConfig';
import { originSchemaValidation } from '../validations.generated';
export const originSchema = {
    $id: 'urn:wisepipe-common-data:Origin',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1 },
        originID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        dataSources: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:DataSource' } },
        config: { $ref: 'urn:wisepipe-common-data:ImportConfig' },
        discoveryID: { type: 'string', uid: 9 },
        streamID: { type: 'string', minLength: 1 },
        connectionID: { type: 'string', uid: 9 },
        hidden: { type: 'boolean' }
    },
    required: ['orgID', 'originID', 'name', 'dataSources', 'config']
};
let Origin = Origin_1 = class Origin {
    constructor(orgID, originID, name, dataSources, config, discoveryID, streamID, connectionID, hidden) {
        // I don't think this logic can be expressed using JSON Schema
        if (config.needsDiscovery) {
            if (config.importConfigType !== ImportConfigType.S3Csv && // discoveryID does not exist for quick import
                config.importConfigType !== ImportConfigType.Excel &&
                config.importConfigType !== ImportConfigType.Fwf &&
                config.importConfigType !== ImportConfigType.EltApi &&
                !discoveryID)
                throw new Error("The field 'discoveryID' is required.");
            // excel/sftp/onedrive does not need stream id as it imports all sheets at once
            if (config.importConfigType !== ImportConfigType.S3Csv && // streamId does not exist for quick import
                config.importConfigType !== ImportConfigType.Excel &&
                config.importConfigType !== ImportConfigType.Sftp &&
                config.importConfigType !== ImportConfigType.AmazonS3 &&
                config.importConfigType !== ImportConfigType.Fwf &&
                config.importConfigType !== ImportConfigType.OneDrive &&
                config.importConfigType !== ImportConfigType.EltApi &&
                !streamID)
                throw new Error("The field 'streamID' is required.");
            // Include once Origins with Connection v1 are obsolete
            // if (!connectionID) throw new Error("The field 'connectionID' is required.")
        }
        this.orgID = orgID;
        this.originID = originID;
        this.name = name;
        this.dataSources = dataSources;
        this.config = config;
        // Discovery
        this.discoveryID = discoveryID;
        this.streamID = streamID;
        this.connectionID = connectionID;
        this.hidden = hidden ?? false;
        JSON.validate(this, Origin_1);
    }
    get bufferID() {
        return Origin_1.bufferID(this.originID);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(originID) {
        return Utils.base64StringToBuffer(originID);
    }
};
Origin = Origin_1 = __decorate([
    JsonSchemaV2(originSchema, originSchemaValidation)
], Origin);
export { Origin };
//# sourceMappingURL=origin.js.map